export const APP_CONFIG = Object.freeze({
  systemName: process.env.REACT_APP_SYSTEM_NAME || "Esquinita",
  timeZone: process.env.REACT_APP_TIME_ZONE || "America/Guatemala",
});

export default APP_CONFIG;
